import { Box, Text, Flex } from "@chakra-ui/react";

const FitmentInterpretation = () => {
  const fitmentInterpretation = [
    {
      label: "High",
      value: "35+",
    },
    {
      label: "Above Average",
      value: "30-35",
    },
    {
      label: "Average",
      value: "15-30",
    },
    {
      label: "Below Average",
      value: "1-10",
    },
  ];
  return (
    <Box borderWidth="1px" borderRadius="lg" pt="2" px="6">
      <Text textAlign="center" mb="10">
        Fitment Interpretation
      </Text>
      {fitmentInterpretation.map((item) => (
        <Flex justify="space-between" mb="3" key={item.label}>
          <Text>{item.label}</Text> <Text>{item.value}</Text>
        </Flex>
      ))}
    </Box>
  );
};

export default FitmentInterpretation;
